export default __webpack_public_path__ + "static/media/drstile-website-4.9106a635.jpg";